  <template>
  <div class="loans-table tw-mt-12">
    <div class="table-header">
      <div class="header-left">
        <h2 class="table-title">Borrowers</h2>
      </div>
    </div>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Borrowers</th>
            <th>Email</th>
            <th>Total Loan Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="borrower in borrowers"
            :key="borrower.id"
            class="tw-text-sm"
          >
            <td class="main-cell tw-font-semibold">
              {{ borrower.fname }} {{ borrower.lname }}
            </td>
            <td class="main-cell">
              {{ borrower.email }}
            </td>
            <td class="sub-cell">
              {{ formattedTotalLoanAmount(borrower.loans) }}
            </td>
            <td class="sub-cell tw-whitespace-nowrap tw-relative">
              <router-link
                :to="{
                  name: 'CreditBorrowers',
                  params: { id: borrower._id },
                }"
                class="tw-text-[#4D84FF] hover:tw-bg-transparent hover:tw-text-[#4D84FF] tw-font-medium"
              >
                View borrower
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="showPagination && totalPages > 1"
        class="tw-flex tw-justify-end tw-mr-2 tw-mt-4"
      >
        <Pagination
          :totalPage="totalPages"
          :currentPage="currentPage"
          :maxVisible="5"
          @pageChange="$emit('go-to-page', $event)"
        />
      </div>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/navigation/Pagination.vue";

export default {
  name: "LoansTable",
  components: {
    Pagination,
  },
  props: {
    borrowers: {
      type: Array,
      default: () => [],
    },
    totalBorrowers: {
      type: Number,
      default: () => 0,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
  },
  emits: ["go-to-page"],
  methods: {
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString();
    },
    formattedLoanAmount(amount) {
      return `₦${amount.toLocaleString()}`;
    },
    formatLoanAmount(data) {
      if (!data) {
        console.warn("formatLoanAmount called with null/undefined data");
        return "₦0.00";
      }

      const total = data.reduce((acc, curr) => {
        if (!curr || isNaN(Number(curr?.amount))) {
          console.warn("Invalid loan amount:", curr);
          return acc;
        }
        return acc + Number(curr?.amount);
      }, 0);

      return new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
        minimumFractionDigits: 2,
      }).format(total);
    },

    formattedTotalLoanAmount(data) {
      return this.formatLoanAmount(data);
    },
  },
};
</script>
  
  <style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.table-wrapper {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e4e4e7;
  padding: 0px 24px 10px 24px;
  border-radius: 8px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
}

table {
  width: 100%;
  border-collapse: collapse;
}

.hover:hover {
  background-color: #eee;
}

table th,
table td {
  padding: 20px;
  text-align: left;
}

table th {
  color: #14151a;
  font-weight: 400;
}

table thead {
  font-weight: medium;
  border-bottom: 1px solid #e2e8f0;
}

.main-cell {
  color: #001140;
}

.sub-cell {
  color: #4f5877;
}

.header-left {
  display: flex;
  flex-direction: column;
}

.table-title {
  font-size: 18px;
  font-weight: bold;
}

.borrowers-info {
  color: #4c5b90;
  font-size: 14px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-input {
  border: none;
  background: #f3f4f6;
  padding: 8px 12px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
}

.sort-button {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #e4e4e7;
  background: white;
  color: #71717a;
  padding: 8px 12px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.arrow-icon {
  font-size: 12px;
  color: #4b5563;
}

.table-footer {
  text-align: right;
  margin-top: 15px;
}

.see-all-link {
  color: #2563eb;
  font-size: 14px;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
}

.see-all-link:hover {
  text-decoration: none;
}
</style>
  